import { StyleWrapper } from "./style"

interface Props {
    children: React.ReactNode;
    center?: boolean;
}
export const Wrapper: React.FC<Props> = ({ children, center }) => {
    return (
        <StyleWrapper $center={center ?? false}>
            {children}
        </StyleWrapper>
    )
}